<template>
  <div class="sm-report-details">
    <div class="sm-wrap">
      <breadcrumbs-block :crumbs="breadcrumbs" />
      <h3>Report details</h3>
      <div class="sm-report-details__top">
        <period-select
          :preselect="false"
          :startFrom="from"
          :startTo="to"
          @set-period="switchPeriod"
        />
        <btn-block
          :type="'grey-cut'"
          :text="'Export CSV report'"
          :icon="'icon-export'"
          @click="requestCSV"
        />
      </div>
      <div class="sm-report-details__table">
        <div class="sm-mobile-table sm-report-details__table-mobile">
          <div class="sm-mobile-table-item header">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-th name">Name</div>
              <div class="sm-mobile-table-item-row-th sum sm-txt-center">Usage / (Cost)</div>
              <div class="sm-mobile-table-item-row-th payment sm-txt-center">Payments</div>
              <div class="sm-mobile-table-item-row-th control-arrow"></div>
            </div>
          </div>

          <div
            v-for="item in charges"
            :key="item.account_id"
            class="sm-mobile-table-item"
            :class="{
              'open': item.isOpen
            }"
          >
            <div 
              class="sm-mobile-table-item-row"
              @click="toggleItem(item)"
            >
              <div class="sm-mobile-table-item-row-elem name">
                <a
                  href="#"
                  class="sm-link"  
                  @click.prevent="$router.push(`customer/${item.account_id}`)"
                >{{item.account_name}}</a>
              </div>
              <div class="sm-mobile-table-item-row-elem sum sm-txt-center">{{formatPrice(item.total_space)}} / ({{formatPrice(item.total_spheremail)}})</div>
              <div class="sm-mobile-table-item-row-elem payment sm-txt-center">{{formatPrice(item.total_payment)}}</div>
              <div class="sm-mobile-table-item-row-elem control-arrow">
                <include-svg :name="'icon-arrow-b-big'" />
              </div>
            </div>
            <ul class="sm-mobile-table-item-dropdown">
              <li v-if="item.hasOwnProperty('beginning_balance')">
                <span class="sm-txt-strong">Beginning balance</span>
                <span class="sm-txt-strong">{{formatPrice(item.beginning_balance)}}</span>
              </li>
              <li>
                <table class="sm-table sm-report-details__table-items">
                  <thead>
                    <tr class="sm-txt-upper">
                      <th>Date</th>
                      <th>Description</th>
                      <th class="sm-txt-center">Usage</th>
                      <th class="sm-txt-center">(Cost)</th>
                      <th class="sm-txt-center">Payments</th>
                      <!-- <th class="sm-txt-right">Status</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(entry, index) in item.items"
                      :key="index"
                    >
                      <td>
                        <template v-if="viewPort == 'large'">{{entry.date | moment('MMMM D, YYYY')}}</template>
                        <template v-else>{{entry.date | moment('MMM D, YYYY')}}</template>
                      </td>
                      <td>{{entry.description == 'Registered Agent Service' && providerCountry ===  "Australia"? 'Public Officer service' : entry.description}}</td>
                      <td class="sm-txt-center">
                        <template v-if="!entry.amount">{{formatPrice(entry.space_amount)}}</template>
                      </td>
                      <td class="sm-txt-center">
                        <template v-if="!entry.amount">({{formatPrice(entry.spheremail_amount)}})</template>
                      </td>
                      <td class="sm-txt-center">
                        <template v-if="entry.amount">{{formatPrice(entry.amount)}}</template>
                      </td>
                      <!-- <td class="sm-txt-right">{{entry.status || ''}}</td> -->
                    </tr>
                  </tbody>
                </table>
              </li>
              <li v-if="item.hasOwnProperty('ending_balance')">
                <span class="sm-txt-strong">Ending balance</span>
                <span class="sm-txt-strong">{{formatPrice(item.ending_balance)}}</span>
              </li>
            </ul>
          </div>

          <div class="sm-mobile-table-item">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-elem name sm-txt-right sm-h5 sm-txt-strong">Total:</div>
              <div class="sm-mobile-table-item-row-elem sum sm-txt-center sm-h5 sm-txt-strong">{{formatPrice(total.space)}} / ({{formatPrice(total.spheremail)}})</div>
              <div class="sm-mobile-table-item-row-elem payment sm-txt-center sm-h5 sm-txt-strong">{{formatPrice(total.payment)}}</div>
              <div class="sm-mobile-table-item-row-elem control-arrow"></div>
            </div>
          </div>

          <paginate-block
            v-if="charges.length"
            v-model="paginate.limit"
            :pages="paginate.pages" 
            :page="paginate.page"
            :onPage="paginate.limit"
            :morePages="paginate.morePages"
            :items="paginate.count"
            @showMore="handleShowMore"
          />
        </div>
      </div>
    </div>
    <a
      href="#"
      :ref="'link'"
      class="sm-report-details__download"
    >Link</a>

    <sm-spinner :show="showSpinner" :isGlobal="true" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Spinner from '@/components/Spinner';
import PeriodSelect from '@/components/reports/PeriodSelect';
import { mapActions, mapGetters } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
import ViewPort from '@/mixins/ViewPort';
import PaginateBlock from '@/components/PaginateBlock';

export default {
  name: 'report-details',
  components: {
    'breadcrumbs-block': Breadcrumbs,
    'sm-spinner': Spinner,
    'period-select': PeriodSelect,
    'paginate-block': PaginateBlock,
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: 'reports',
          name: 'admin-reports',
          text: 'Reports'
        },
        {
          link: 'report-details',
          name: 'admin-report-details',
          text: 'Report details',
          current: true
        }
      ],
      from: null,
      to: null,
      charges: [],
      total: {
        space: null,
        spheremail: null,
        payment: null,
        beginning_balance: null,
        ending_balance: null
      },
      allowedBreakpoints: [
        'medium',
        'large'
      ],
      providerCountry:'United States',

      showSpinner: false,

      paginate: {
        limit: 20,
        page: 1,
        pages: 0,
        morePages: 0,
        count: 0,

      }
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      userAccount: 'account/userAccount',
      provider: 'provider',
    }),
  },
  created() {
    let query = this.$route.query;
    this.from = query.from;
    this.to = query.to;
  
    if (
        !this.from || 
        this.from.toLowerCase().includes('invalid') ||
        !this.to ||
        this.to.toLowerCase().includes('invalid')  
      ) {
      this.redirectToCharges();
      return;
    }

    if (query.limit)
      this.paginate.limit = parseInt(query.limit);

    if (query.page)
      this.paginate.page = parseInt(query.page);

    this.getData();

    this.getCountryById(this.provider.country_id).then(res => {
      this.providerCountry = res.name
    })
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getDetails: 'reports/getDetails',
      getDetailsCSV: 'reports/getDetailsCSV',
      getCountryById: 'getCountryById'
    }),
    formatPrice: FormatPrice,
    prepateItems(arr) {
      return arr.map(item => {
        return {
          ...item,
          isOpen: false
        };
      });
    },
    redirectToCharges() {
      this.$router.push('reports?tab=charge');
    },
    toggleItem(item) {
      item.isOpen = !item.isOpen;
    },
    getData(isShowMore=false) {
      this.showSpinner = true;

      this.paginate.morePages = isShowMore ? (this.paginate.morePages + 1) : 0;

      this.getDetails({
        from: this.from,
        to: this.to,
        limit: this.paginate.limit,
        page: this.paginate.page + this.paginate.morePages
      })
        .then(res => {
          this.charges = isShowMore ? [...this.charges, ...this.prepateItems(res.charges)] : this.prepateItems(res.charges);

          this.total.space = res.total_space;
          this.total.spheremail = res.total_spheremail;
          this.total.payment = res.total_payment;

          this.paginate.page = isShowMore ? this.paginate.page : res.page;
          this.paginate.pages = res.total_pages;
          this.paginate.count = res.total_count;
          this.showSpinner = false;
        })
        .catch(e => {
          this.showSpinner = false;
        })
    },

    switchPeriod(from, to) {
      if (!from || (isNaN(from) && from.split('-').length != 3))
        from = new Date().setFullYear(new Date().getFullYear() - 10);

      if (!to || (isNaN(to) && from.split('-').length != 3))
        to = new Date();

      this.from = this.$moment(from).format('YYYY-MM-DD');
      this.to = this.$moment(to).format('YYYY-MM-DD');

      this.$router.push({
        query: {
          from: this.from,
          to: this.to
        }
      });

      this.getData();
    },
    requestCSV() {
      this.showSpinner = true;

      if (!this.from) {
        let from = new Date().setFullYear(new Date().getFullYear() - 10);
        this.from = this.$moment(from).format('YYYY-MM-DD');
      }

      if (!this.to) {
        let to = new Date();
        this.to = this.$moment(to).format('YYYY-MM-DD');
      }

      this.getDetailsCSV({
        from: this.from,
        to: this.to
      })
        .then(res => {
          let link = this.$refs.link;
          let encodedUri = encodeURI(`data:text/csv;charset=utf-8,${res}`);
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "result.csv");
          link.click();

          this.$emit('finishCSV');
          this.showSpinner = false;
        })
        .catch(e => {
          this.showSpinner = false;
        });
    },
    handleShowMore() {
      this.getData(true);
    }
  },
  watch: {
    '$route.query.limit'(val) {
      if (val)
        this.paginate.limit = parseInt(val);
        this.paginage.page = 1;

      this.getData();
    },
    '$route.query.page'(val) {
      if (val)
        this.paginate.page = parseInt(val);

      this.getData();
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/reports/_report-details.scss';
</style>